import { IonSkeletonText } from "@ionic/react";

import s from "./CancelSubscriptionSkeleton.module.scss";

export const CancelSubscriptionSkeleton = () => (
  <div className={s.root}>
    <IonSkeletonText animated className={s.heroBlock} />
    <IonSkeletonText animated className={s.titleLine} />
    <IonSkeletonText animated className={s.bodyLine} />
    <IonSkeletonText animated className={s.bodyLineShort} />
    <div className={s.actions}>
      <IonSkeletonText animated className={s.primaryBtn} />
      <IonSkeletonText animated className={s.secondaryBtn} />
    </div>
  </div>
);
